export default {
    slug: {
        required: { value: true, message: "El slug es obligatorio" }
    },
    env: {
        required: { value: true, message: "El entorno es obligatorio" }
    },
};
